export const environment = {
  production: true,
  qualys: false,
  apiUrl: 'https://de-mils-insp-204064355420.us-central1.run.app/'
};
